<script>
  import { Stack } from "creditdesign-svelte-components";

  export let scaleLabel = "";
</script>

<style>
  .container {
    max-width: var(--measure-small);
    margin-right: auto;
    margin-left: auto;
  }

  .color-block {
    display: block;
    max-width: 100%;
    height: 15px;
    margin-right: 0.5em;
    margin-left: 0.5em;
    background: linear-gradient(to left, #a52b30, #fff, #3568a8);
  }

  .label-container {
    display: flex;
    align-content: center;
    justify-content: space-between;
  }
</style>

<div class="container" aria-hidden="true">
  <Stack stackSpace="var(--s-4)">
    <p>{scaleLabel}</p>
    <div class="color-block" />
    <div class="label-container">
      <span>–5</span><span>0</span><span>5</span>
    </div>
  </Stack>
</div>
